import { render, staticRenderFns } from "./IviewTable_old.vue?vue&type=template&id=0978caf2&scoped=true&"
import script from "./IviewTable_old.vue?vue&type=script&lang=js&"
export * from "./IviewTable_old.vue?vue&type=script&lang=js&"
import style0 from "./IviewTable_old.vue?vue&type=style&index=0&id=0978caf2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0978caf2",
  null
  
)

export default component.exports